import { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import WhatsApp from "../../assets/whatsapp.png";

import experienceHero from "../../assets/place1.jpg";

import battalangunduwa1 from "../../assets/baththalangunduwa1.jpg";
import battalangunduwa2 from "../../assets/baththalangunduwa2.jpg";
import battalangunduwa3 from "../../assets/place1.jpg";

function Battalangunduwa() {

    const [activeImage, setActiveImage] = useState(battalangunduwa1);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${experienceHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Battalangunduwa Island
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        A Hidden Fishing Island Escape in Sri Lanka
                    </p>
                </div>
            </section>

            {/* ================= SECTION ================= */}
            <section className="bg-white py-16 px-4 sm:px-8 lg:px-20">
                <div className="max-w-7xl mx-auto">

                    <h2
                        data-aos="fade-up"
                        className="text-center text-2xl sm:text-3xl md:text-4xl font-semibold text-blue-900 tracking-wide"
                    >
                        Discover Battalangunduwa
                    </h2>

                    <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                        {/* Text */}
                        <div data-aos="fade-right" className="space-y-5 text-gray-700 text-sm sm:text-base leading-relaxed">

                            <p>
                                Battalangunduwa Island is a remote fishing island located off Sri Lanka’s northwestern
                                coast. Known for its untouched beaches and peaceful atmosphere, it offers a truly
                                off-the-grid travel experience.
                            </p>

                            <p>
                                The island is home to a small fishing community, where visitors can witness traditional
                                fishing lifestyles, explore salt pans, and enjoy scenic lagoon views.
                            </p>

                            <p>
                                Battalangunduwa is perfect for camping, sunset watching, bird photography, and relaxing
                                on quiet sandy shores far from crowded tourist areas.
                            </p>

                            <p>
                                With its rustic charm, raw natural beauty, and authentic island culture, Battalangunduwa
                                provides a unique adventure for travelers seeking hidden destinations.
                            </p>

                        </div>

                        {/* Image Section */}
                        <div data-aos="fade-left" className="relative">

                            <img
                                src={activeImage}
                                alt="Battalangunduwa Island"
                                className="rounded-lg shadow-xl w-full h-[350px] object-cover transition duration-300"
                            />

                            <div className="flex gap-3 mt-4 justify-center">
                                {[battalangunduwa1, battalangunduwa2, battalangunduwa3].map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        onClick={() => setActiveImage(img)}
                                        className={`w-20 h-14 object-cover rounded-md shadow cursor-pointer transition
                                        ${activeImage === img
                                                ? "ring-2 ring-blue-600 scale-105"
                                                : "opacity-70 hover:opacity-100"
                                            }`}
                                        alt="thumbnail"
                                    />
                                ))}
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            <div className="fixed bottom-20 right-5 z-50">

                {/* ICON BUTTON */}
                <div
                    onClick={() => {
                        const dropdown = document.querySelector(".goog-te-gadget-simple");
                        if (dropdown) {
                            dropdown.click();
                        } else {

                        }
                    }}
                    className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center cursor-pointer hover:scale-110 transition"
                >
                    <img
                        src="https://www.gstatic.com/images/branding/product/1x/translate_24dp.png"
                        alt="Translate"
                        className="w-7 h-7"
                    />

                    {/* Tooltip */}
                    <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-black text-white text-xs px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
                        Change Language
                    </div>

                </div>

                {/* HIDDEN GOOGLE TRANSLATE */}
                <div id="google_translate_element" className="absolute opacity-0 pointer-events-none"></div>

            </div>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94750800887"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-6 right-6 z-50 group"
            >
                <div className="relative">

                    {/* Pulse Ring */}
                    <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-30 animate-ping"></span>

                    {/* Button */}
                    <img
                        src={WhatsApp}
                        alt="Chat on WhatsApp"
                        className="relative h-12 w-12 sm:h-12 sm:w-12 rounded-full shadow-2xl border-2 border-white transition duration-300 ease-in-out group-hover:scale-110 group-hover:rotate-6"
                    />

                    {/* Tooltip */}
                    <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-black text-white text-xs px-3 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
                        Chat with us
                    </div>

                </div>
            </a>

        </div>
    );
}

export default Battalangunduwa;